//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class EsraCoatingsAPIClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getUserAppRoles(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Authorization/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAppRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAppRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserAppRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatingProductById(productId: string): Observable<CoatingProductViewModel> {
        let url_ = this.baseUrl + "/api/CoatingProduct/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingProductById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingProductById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingProductViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingProductViewModel>;
        }));
    }

    protected processGetCoatingProductById(response: HttpResponseBase): Observable<CoatingProductViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingProductViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateCoatingProduct(productId: string, body?: CoatingProductViewModel | undefined): Observable<CoatingProductViewModel> {
        let url_ = this.baseUrl + "/api/CoatingProduct/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoatingProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoatingProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingProductViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingProductViewModel>;
        }));
    }

    protected processUpdateCoatingProduct(response: HttpResponseBase): Observable<CoatingProductViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingProductViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCoatingProductsByIds(body?: string[] | undefined): Observable<CoatingProductViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingProduct/getbyids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingProductsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingProductsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingProductViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingProductViewModel[]>;
        }));
    }

    protected processGetCoatingProductsByIds(response: HttpResponseBase): Observable<CoatingProductViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatingProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatingProductsByManufacturerName(name: string): Observable<CoatingProductMinimalViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingProduct/getByManufacturer/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingProductsByManufacturerName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingProductsByManufacturerName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingProductMinimalViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingProductMinimalViewModel[]>;
        }));
    }

    protected processGetCoatingProductsByManufacturerName(response: HttpResponseBase): Observable<CoatingProductMinimalViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatingProductMinimalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    getCoatingProductsIdByName(name: string): Observable<CoatingProductViewModel> {
        let url_ = this.baseUrl + "/api/CoatingProduct/getBy/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingProductsIdByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingProductsIdByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingProductViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingProductViewModel>;
        }));
    }

    protected processGetCoatingProductsIdByName(response: HttpResponseBase): Observable<CoatingProductViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingProductViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param techSpec (optional) 
     * @return OK
     */
    getAllCoatingProductLabels(techSpec?: string | undefined): Observable<EsraRecordLabel[]> {
        let url_ = this.baseUrl + "/api/CoatingProduct/all?";
        if (techSpec === null)
            throw new Error("The parameter 'techSpec' cannot be null.");
        else if (techSpec !== undefined)
            url_ += "techSpec=" + encodeURIComponent("" + techSpec) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingProductLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingProductLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsraRecordLabel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsraRecordLabel[]>;
        }));
    }

    protected processGetAllCoatingProductLabels(response: HttpResponseBase): Observable<EsraRecordLabel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EsraRecordLabel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    addCoatingRevision(body?: CoatingRevisionViewModel | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddCoatingRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoatingRevisionViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateRevisionMembers(revisionId: number, body?: RevisionApprovalViewModel[] | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/updatemembers";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRevisionMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRevisionMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processUpdateRevisionMembers(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addApproverToRevision(revisionId: number, body?: RevisionApprovalViewModel | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/approver";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddApproverToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddApproverToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddApproverToRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    removeRevisionReviewer(revisionId: number, reviewerId: string): Observable<RevisionApprovalViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/reviewer/{reviewerId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (reviewerId === undefined || reviewerId === null)
            throw new Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRevisionReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRevisionReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionApprovalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionApprovalViewModel>;
        }));
    }

    protected processRemoveRevisionReviewer(response: HttpResponseBase): Observable<RevisionApprovalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionApprovalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    removeRevisionApprover(revisionId: number, reviewerId: string): Observable<RevisionApprovalViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/approver/{reviewerId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (reviewerId === undefined || reviewerId === null)
            throw new Error("The parameter 'reviewerId' must be defined.");
        url_ = url_.replace("{reviewerId}", encodeURIComponent("" + reviewerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRevisionApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRevisionApprover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionApprovalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionApprovalViewModel>;
        }));
    }

    protected processRemoveRevisionApprover(response: HttpResponseBase): Observable<RevisionApprovalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionApprovalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    sendRevisionforReview(revisionId: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/sendtoreviewers";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRevisionforReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRevisionforReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processSendRevisionforReview(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDefaultReviewers(): Observable<RevisionApprovalViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingRevision/defaultReviewers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionApprovalViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionApprovalViewModel[]>;
        }));
    }

    protected processGetDefaultReviewers(response: HttpResponseBase): Observable<RevisionApprovalViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevisionApprovalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDefaultApprovers(): Observable<RevisionApprovalViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingRevision/defaultApprovers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionApprovalViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionApprovalViewModel[]>;
        }));
    }

    protected processGetDefaultApprovers(response: HttpResponseBase): Observable<RevisionApprovalViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevisionApprovalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    sendRevisionforApproval(revisionId: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/sendtoapprovers";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRevisionforApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRevisionforApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processSendRevisionforApproval(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    approveRevisionAsReviewer(revisionId: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/approveasreviewer";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveRevisionAsReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRevisionAsReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processApproveRevisionAsReviewer(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rejectRevisionAsReviewer(revisionId: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/rejectasreviewer";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectRevisionAsReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRevisionAsReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processRejectRevisionAsReviewer(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    approveRevision(revisionId: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/approve";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processApproveRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rejectRevision(revisionId: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/reject";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processRejectRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatingRevisionById(id: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingRevisionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingRevisionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processGetCoatingRevisionById(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateCoatingRevisionById(id: number, body?: CoatingRevisionViewModel | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoatingRevisionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoatingRevisionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processUpdateCoatingRevisionById(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteRevisionById(id: number): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRevisionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRevisionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processDeleteRevisionById(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllRevisions(): Observable<CoatingRevisionViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingRevision/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel[]>;
        }));
    }

    protected processGetAllRevisions(response: HttpResponseBase): Observable<CoatingRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatingRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllRevisionsSummarazied(): Observable<RevisionSummaryViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingRevision/allSummarized";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRevisionsSummarazied(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRevisionsSummarazied(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionSummaryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionSummaryViewModel[]>;
        }));
    }

    protected processGetAllRevisionsSummarazied(response: HttpResponseBase): Observable<RevisionSummaryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevisionSummaryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created
     */
    addCoatingSolutionToRevision(revisionId: number, coatingSolutionName: string): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingsolution/{coatingSolutionName}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (coatingSolutionName === undefined || coatingSolutionName === null)
            throw new Error("The parameter 'coatingSolutionName' must be defined.");
        url_ = url_.replace("{coatingSolutionName}", encodeURIComponent("" + coatingSolutionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingSolutionToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingSolutionToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddCoatingSolutionToRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoatingRevisionViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    removeCoatingSolutionFromRevision(revisionId: number, coatingSolutionName: string): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingsolution/{coatingSolutionName}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (coatingSolutionName === undefined || coatingSolutionName === null)
            throw new Error("The parameter 'coatingSolutionName' must be defined.");
        url_ = url_.replace("{coatingSolutionName}", encodeURIComponent("" + coatingSolutionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCoatingSolutionFromRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCoatingSolutionFromRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processRemoveCoatingSolutionFromRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    addCoatingSolutionToBeDeleted(revisionId: number, coatingSolutionName: string): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingsolution/{coatingSolutionName}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (coatingSolutionName === undefined || coatingSolutionName === null)
            throw new Error("The parameter 'coatingSolutionName' must be defined.");
        url_ = url_.replace("{coatingSolutionName}", encodeURIComponent("" + coatingSolutionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingSolutionToBeDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingSolutionToBeDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddCoatingSolutionToBeDeleted(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param solutionName (optional) 
     * @param solutionNotes (optional) 
     * @param coatingSystemId (optional) 
     * @return OK
     */
    addNewCoatingSolutionToRevision(revisionId: number, solutionName?: string | undefined, solutionNotes?: string | undefined, coatingSystemId?: string | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingsolution?";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (solutionName === null)
            throw new Error("The parameter 'solutionName' cannot be null.");
        else if (solutionName !== undefined)
            url_ += "solutionName=" + encodeURIComponent("" + solutionName) + "&";
        if (solutionNotes === null)
            throw new Error("The parameter 'solutionNotes' cannot be null.");
        else if (solutionNotes !== undefined)
            url_ += "solutionNotes=" + encodeURIComponent("" + solutionNotes) + "&";
        if (coatingSystemId === null)
            throw new Error("The parameter 'coatingSystemId' cannot be null.");
        else if (coatingSystemId !== undefined)
            url_ += "coatingSystemId=" + encodeURIComponent("" + coatingSystemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewCoatingSolutionToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewCoatingSolutionToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddNewCoatingSolutionToRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    addCoatingSystemsToRevision(revisionId: number, body?: string[] | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/addCoatingSystems";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingSystemsToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingSystemsToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddCoatingSystemsToRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoatingRevisionViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addNewCoatingSystemToRevision(revisionId: number, body?: CoatingSystemViewModel | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingsystem";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewCoatingSystemToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewCoatingSystemToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddNewCoatingSystemToRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param removeRelatedCoatingSolutions (optional) 
     * @return Accepted
     */
    removeCoatingSystemFromRevision(revisionId: number, coatingSystemId: string, removeRelatedCoatingSolutions?: boolean | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingsystem/{coatingSystemId}?";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (coatingSystemId === undefined || coatingSystemId === null)
            throw new Error("The parameter 'coatingSystemId' must be defined.");
        url_ = url_.replace("{coatingSystemId}", encodeURIComponent("" + coatingSystemId));
        if (removeRelatedCoatingSolutions === null)
            throw new Error("The parameter 'removeRelatedCoatingSolutions' cannot be null.");
        else if (removeRelatedCoatingSolutions !== undefined)
            url_ += "removeRelatedCoatingSolutions=" + encodeURIComponent("" + removeRelatedCoatingSolutions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCoatingSystemFromRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCoatingSystemFromRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processRemoveCoatingSystemFromRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    addCoatingSystemsToBeDeleted(revisionId: number, body?: string[] | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/addCoatingSystemsToBeDeleted";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingSystemsToBeDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingSystemsToBeDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddCoatingSystemsToBeDeleted(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoatingRevisionViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created
     */
    addCoatingProductToRevision(revisionId: number, coatingProductGuid: string): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingproduct/{coatingProductGuid}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (coatingProductGuid === undefined || coatingProductGuid === null)
            throw new Error("The parameter 'coatingProductGuid' must be defined.");
        url_ = url_.replace("{coatingProductGuid}", encodeURIComponent("" + coatingProductGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingProductToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingProductToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddCoatingProductToRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoatingRevisionViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    addNewCoatingProductToRevision(revisionId: number, body?: CoatingProductViewModel | undefined): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingproduct";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewCoatingProductToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewCoatingProductToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddNewCoatingProductToRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoatingRevisionViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    removeCoatingProductFromRevision(revisionId: number, coatingProductId: string): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingproduct/{coatingProductId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (coatingProductId === undefined || coatingProductId === null)
            throw new Error("The parameter 'coatingProductId' must be defined.");
        url_ = url_.replace("{coatingProductId}", encodeURIComponent("" + coatingProductId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCoatingProductFromRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCoatingProductFromRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processRemoveCoatingProductFromRevision(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    addCoatingProductToBeDeleted(revisionId: number, coatingProductId: string): Observable<CoatingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/coatingProduct/{coatingProductId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (coatingProductId === undefined || coatingProductId === null)
            throw new Error("The parameter 'coatingProductId' must be defined.");
        url_ = url_.replace("{coatingProductId}", encodeURIComponent("" + coatingProductId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingProductToBeDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingProductToBeDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel>;
        }));
    }

    protected processAddCoatingProductToBeDeleted(response: HttpResponseBase): Observable<CoatingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resendNotifications(body?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CoatingRevision/resendNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processResendNotifications(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    addComment(revisionId: number, body?: RevisionCommentViewModel | undefined): Observable<RevisionCommentViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/comment";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionCommentViewModel>;
        }));
    }

    protected processAddComment(response: HttpResponseBase): Observable<RevisionCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RevisionCommentViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateComment(revisionId: number, body?: RevisionCommentViewModel | undefined): Observable<RevisionCommentViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/comment";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionCommentViewModel>;
        }));
    }

    protected processUpdateComment(response: HttpResponseBase): Observable<RevisionCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = RevisionCommentViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    deleteComment(revisionId: number, commentId: number): Observable<RevisionCommentViewModel> {
        let url_ = this.baseUrl + "/api/CoatingRevision/{revisionId}/comment/{commentId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionCommentViewModel>;
        }));
    }

    protected processDeleteComment(response: HttpResponseBase): Observable<RevisionCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = RevisionCommentViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatingSystemSolutionByName(name: string): Observable<CoatingSystemSolutionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingSolution/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingSystemSolutionByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingSystemSolutionByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemSolutionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemSolutionViewModel>;
        }));
    }

    protected processGetCoatingSystemSolutionByName(response: HttpResponseBase): Observable<CoatingSystemSolutionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingSystemSolutionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    getCoatingSystemSolutionById(id: string): Observable<CoatingSystemSolutionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingSolution/CoatingSystemSolution/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingSystemSolutionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingSystemSolutionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemSolutionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemSolutionViewModel>;
        }));
    }

    protected processGetCoatingSystemSolutionById(response: HttpResponseBase): Observable<CoatingSystemSolutionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingSystemSolutionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateCoatingSystemSolution(body?: CoatingSystemSolutionViewModel | undefined): Observable<CoatingSystemSolutionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingSolution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoatingSystemSolution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoatingSystemSolution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemSolutionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemSolutionViewModel>;
        }));
    }

    protected processUpdateCoatingSystemSolution(response: HttpResponseBase): Observable<CoatingSystemSolutionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingSystemSolutionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param techSpec (optional) 
     * @return OK
     */
    getAllCoatingSolutionLabels(techSpec?: string | undefined): Observable<EsraRecordLabel[]> {
        let url_ = this.baseUrl + "/api/CoatingSolution/all?";
        if (techSpec === null)
            throw new Error("The parameter 'techSpec' cannot be null.");
        else if (techSpec !== undefined)
            url_ += "techSpec=" + encodeURIComponent("" + techSpec) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingSolutionLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingSolutionLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsraRecordLabel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsraRecordLabel[]>;
        }));
    }

    protected processGetAllCoatingSolutionLabels(response: HttpResponseBase): Observable<EsraRecordLabel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EsraRecordLabel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchCoatingSolutions(body?: SearchRequest | undefined): Observable<SearchResponse_1OfCoatingSystemSolutionViewModel> {
        let url_ = this.baseUrl + "/api/CoatingSolutionSearch/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCoatingSolutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCoatingSolutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfCoatingSystemSolutionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfCoatingSystemSolutionViewModel>;
        }));
    }

    protected processSearchCoatingSolutions(response: HttpResponseBase): Observable<SearchResponse_1OfCoatingSystemSolutionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfCoatingSystemSolutionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatingSystemById(coatingSystemId: string): Observable<CoatingSystemViewModel> {
        let url_ = this.baseUrl + "/api/CoatingSystem/coatingSystemId/{coatingSystemId}";
        if (coatingSystemId === undefined || coatingSystemId === null)
            throw new Error("The parameter 'coatingSystemId' must be defined.");
        url_ = url_.replace("{coatingSystemId}", encodeURIComponent("" + coatingSystemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingSystemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingSystemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemViewModel>;
        }));
    }

    protected processGetCoatingSystemById(response: HttpResponseBase): Observable<CoatingSystemViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingSystemViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatingSystemByUniqueId(id: string): Observable<CoatingSystemViewModel> {
        let url_ = this.baseUrl + "/api/CoatingSystem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingSystemByUniqueId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingSystemByUniqueId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemViewModel>;
        }));
    }

    protected processGetCoatingSystemByUniqueId(response: HttpResponseBase): Observable<CoatingSystemViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingSystemViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateCoatingSystemByUniqueId(id: string, body?: CoatingSystemViewModel | undefined): Observable<CoatingSystemViewModel> {
        let url_ = this.baseUrl + "/api/CoatingSystem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoatingSystemByUniqueId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoatingSystemByUniqueId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemViewModel>;
        }));
    }

    protected processUpdateCoatingSystemByUniqueId(response: HttpResponseBase): Observable<CoatingSystemViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CoatingSystemViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param techSpec (optional) 
     * @return OK
     */
    getAllCoatingSystemLabels(techSpec?: string | undefined): Observable<EsraRecordLabel[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/all?";
        if (techSpec === null)
            throw new Error("The parameter 'techSpec' cannot be null.");
        else if (techSpec !== undefined)
            url_ += "techSpec=" + encodeURIComponent("" + techSpec) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingSystemLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingSystemLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsraRecordLabel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsraRecordLabel[]>;
        }));
    }

    protected processGetAllCoatingSystemLabels(response: HttpResponseBase): Observable<EsraRecordLabel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EsraRecordLabel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param techSpec (optional) 
     * @return OK
     */
    getAllCoatingSystemRevisions(techSpec?: string | undefined): Observable<CoatingRevisionViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/revisions?";
        if (techSpec === null)
            throw new Error("The parameter 'techSpec' cannot be null.");
        else if (techSpec !== undefined)
            url_ += "techSpec=" + encodeURIComponent("" + techSpec) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingSystemRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingSystemRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingRevisionViewModel[]>;
        }));
    }

    protected processGetAllCoatingSystemRevisions(response: HttpResponseBase): Observable<CoatingRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatingRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCoatingSystemCategories(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingSystemCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingSystemCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllCoatingSystemCategories(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCoatingSystemServices(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingSystemServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingSystemServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllCoatingSystemServices(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatingSystemSelections(): Observable<CoatingSystemViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/selection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingSystemSelections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingSystemSelections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemViewModel[]>;
        }));
    }

    protected processGetCoatingSystemSelections(response: HttpResponseBase): Observable<CoatingSystemViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatingSystemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCoatingSystemTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingSystemTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingSystemTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllCoatingSystemTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftRevisionId (optional) 
     * @return OK
     */
    getAllCoatingSystemIds(draftRevisionId?: number | undefined): Observable<SimpleObjectViewModel[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/coatingSystemIds?";
        if (draftRevisionId === null)
            throw new Error("The parameter 'draftRevisionId' cannot be null.");
        else if (draftRevisionId !== undefined)
            url_ += "draftRevisionId=" + encodeURIComponent("" + draftRevisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCoatingSystemIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCoatingSystemIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleObjectViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleObjectViewModel[]>;
        }));
    }

    protected processGetAllCoatingSystemIds(response: HttpResponseBase): Observable<SimpleObjectViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleObjectViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllManufacturers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/CoatingSystem/manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllManufacturers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllManufacturers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllManufacturers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatNames(): Observable<CoatName[]> {
        let url_ = this.baseUrl + "/api/Coats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatName[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatName[]>;
        }));
    }

    protected processGetCoatNames(response: HttpResponseBase): Observable<CoatName[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCoatPropertyValues(propertyName: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Coats/coatPropertyValues/{propertyName}";
        if (propertyName === undefined || propertyName === null)
            throw new Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatPropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatPropertyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCoatPropertyValues(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    addCoatToCoatingSystem(body?: CoatViewModel | undefined): Observable<CoatViewModel> {
        let url_ = this.baseUrl + "/api/Coats/addcoat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatToCoatingSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatToCoatingSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatViewModel>;
        }));
    }

    protected processAddCoatToCoatingSystem(response: HttpResponseBase): Observable<CoatViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoatViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    removeCoat(coatId: string, coatSystemId: string): Observable<CoatViewModel> {
        let url_ = this.baseUrl + "/api/Coats/removecoat/{coatId}/{coatSystemId}";
        if (coatId === undefined || coatId === null)
            throw new Error("The parameter 'coatId' must be defined.");
        url_ = url_.replace("{coatId}", encodeURIComponent("" + coatId));
        if (coatSystemId === undefined || coatSystemId === null)
            throw new Error("The parameter 'coatSystemId' must be defined.");
        url_ = url_.replace("{coatSystemId}", encodeURIComponent("" + coatSystemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCoat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCoat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatViewModel>;
        }));
    }

    protected processRemoveCoat(response: HttpResponseBase): Observable<CoatViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSystemSelectionReport(revisionId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/systemSelection?";
        if (revisionId === null)
            throw new Error("The parameter 'revisionId' cannot be null.");
        else if (revisionId !== undefined)
            url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/docx"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemSelectionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemSelectionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetSystemSelectionReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getThirdParty(techSpec?: string | undefined, fromRevisionId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/thirdParty?";
        if (techSpec === null)
            throw new Error("The parameter 'techSpec' cannot be null.");
        else if (techSpec !== undefined)
            url_ += "techSpec=" + encodeURIComponent("" + techSpec) + "&";
        if (fromRevisionId === null)
            throw new Error("The parameter 'fromRevisionId' cannot be null.");
        else if (fromRevisionId !== undefined)
            url_ += "fromRevisionId=" + encodeURIComponent("" + fromRevisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/docx"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThirdParty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThirdParty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetThirdParty(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCoatingSolutionReportByName(solutionName: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/CoatingSolution/name/{solutionName}";
        if (solutionName === undefined || solutionName === null)
            throw new Error("The parameter 'solutionName' must be defined.");
        url_ = url_.replace("{solutionName}", encodeURIComponent("" + solutionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingSolutionReportByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingSolutionReportByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCoatingSolutionReportByName(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCoatingSolutionReportById(solutionId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/CoatingSolution/{solutionId}";
        if (solutionId === undefined || solutionId === null)
            throw new Error("The parameter 'solutionId' must be defined.");
        url_ = url_.replace("{solutionId}", encodeURIComponent("" + solutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatingSolutionReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatingSolutionReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCoatingSolutionReportById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateApplicationReportPDF(body?: SearchRequest | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/Application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateApplicationReportPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateApplicationReportPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateApplicationReportPDF(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkspaceReportForSelectedCoatingSolutions(body?: string[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/WorkspaceCoatingSolution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspaceReportForSelectedCoatingSolutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspaceReportForSelectedCoatingSolutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetWorkspaceReportForSelectedCoatingSolutions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTechnologyStandards(): Observable<TechnologyStandardViewModel[]> {
        let url_ = this.baseUrl + "/api/Filters/technologystandards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTechnologyStandards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTechnologyStandards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TechnologyStandardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TechnologyStandardViewModel[]>;
        }));
    }

    protected processGetTechnologyStandards(response: HttpResponseBase): Observable<TechnologyStandardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnologyStandardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param technologyStandard (optional) 
     * @return OK
     */
    getSearchFilters(technologyStandard?: string | undefined): Observable<CoatingsSearchFilterModel[]> {
        let url_ = this.baseUrl + "/api/Filters?";
        if (technologyStandard === null)
            throw new Error("The parameter 'technologyStandard' cannot be null.");
        else if (technologyStandard !== undefined)
            url_ += "technologyStandard=" + encodeURIComponent("" + technologyStandard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingsSearchFilterModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingsSearchFilterModel[]>;
        }));
    }

    protected processGetSearchFilters(response: HttpResponseBase): Observable<CoatingsSearchFilterModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatingsSearchFilterModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param propertyName (optional) 
     * @return OK
     */
    getOptionsForSingleProperty(propertyName?: string | undefined): Observable<CoatingsSearchFilterModel> {
        let url_ = this.baseUrl + "/api/Filters/singleproperty?";
        if (propertyName === null)
            throw new Error("The parameter 'propertyName' cannot be null.");
        else if (propertyName !== undefined)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptionsForSingleProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptionsForSingleProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingsSearchFilterModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingsSearchFilterModel>;
        }));
    }

    protected processGetOptionsForSingleProperty(response: HttpResponseBase): Observable<CoatingsSearchFilterModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoatingsSearchFilterModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnvironmentalIndicatorData(): Observable<EnvironmentIndicatorViewModel> {
        let url_ = this.baseUrl + "/api/Indicator/getEnvironmentalIndicatorData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironmentalIndicatorData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironmentalIndicatorData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnvironmentIndicatorViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnvironmentIndicatorViewModel>;
        }));
    }

    protected processGetEnvironmentalIndicatorData(response: HttpResponseBase): Observable<EnvironmentIndicatorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentIndicatorViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyWorkspace(): Observable<CoatingSystemSolutionViewModel[]> {
        let url_ = this.baseUrl + "/api/Workspace/myworkspace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoatingSystemSolutionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoatingSystemSolutionViewModel[]>;
        }));
    }

    protected processGetMyWorkspace(response: HttpResponseBase): Observable<CoatingSystemSolutionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoatingSystemSolutionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created
     */
    addCoatingSystemSolutionToWorkspaceById(coatingSystemSolutionId: string): Observable<WorkspaceEntryViewModel> {
        let url_ = this.baseUrl + "/api/Workspace/coatingSolution/{coatingSystemSolutionId}";
        if (coatingSystemSolutionId === undefined || coatingSystemSolutionId === null)
            throw new Error("The parameter 'coatingSystemSolutionId' must be defined.");
        url_ = url_.replace("{coatingSystemSolutionId}", encodeURIComponent("" + coatingSystemSolutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoatingSystemSolutionToWorkspaceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoatingSystemSolutionToWorkspaceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceEntryViewModel>;
        }));
    }

    protected processAddCoatingSystemSolutionToWorkspaceById(response: HttpResponseBase): Observable<WorkspaceEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WorkspaceEntryViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param coatingSolutionId (optional) 
     * @return Accepted
     */
    removeCoatingSolutionFromWorkspace(coatingSolutionId?: string | undefined): Observable<WorkspaceEntryViewModel> {
        let url_ = this.baseUrl + "/api/Workspace/coatingSolution?";
        if (coatingSolutionId === null)
            throw new Error("The parameter 'coatingSolutionId' cannot be null.");
        else if (coatingSolutionId !== undefined)
            url_ += "coatingSolutionId=" + encodeURIComponent("" + coatingSolutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCoatingSolutionFromWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCoatingSolutionFromWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceEntryViewModel>;
        }));
    }

    protected processRemoveCoatingSolutionFromWorkspace(response: HttpResponseBase): Observable<WorkspaceEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WorkspaceEntryViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param solutionIds (optional) 
     * @return Accepted
     */
    removeCoatingSolutionsFromWorkspace(solutionIds?: string[] | undefined): Observable<WorkspaceEntryViewModel> {
        let url_ = this.baseUrl + "/api/Workspace/coatingSolutions?";
        if (solutionIds === null)
            throw new Error("The parameter 'solutionIds' cannot be null.");
        else if (solutionIds !== undefined)
            solutionIds && solutionIds.forEach(item => { url_ += "solutionIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCoatingSolutionsFromWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCoatingSolutionsFromWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceEntryViewModel>;
        }));
    }

    protected processRemoveCoatingSolutionsFromWorkspace(response: HttpResponseBase): Observable<WorkspaceEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WorkspaceEntryViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum ApproverType {
    _0 = 0,
    _1 = 1,
}

export class Coat implements ICoat {
    id?: string;
    coatNameId?: string | undefined;
    coatName?: CoatName;
    genericClassification?: string | undefined;
    dft?: string | undefined;
    notes?: string | undefined;
    coatingSystemId!: string;
    coatingSystem?: CoatingSystem;

    constructor(data?: ICoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coatNameId = _data["coatNameId"];
            this.coatName = _data["coatName"] ? CoatName.fromJS(_data["coatName"]) : <any>undefined;
            this.genericClassification = _data["genericClassification"];
            this.dft = _data["dft"];
            this.notes = _data["notes"];
            this.coatingSystemId = _data["coatingSystemId"];
            this.coatingSystem = _data["coatingSystem"] ? CoatingSystem.fromJS(_data["coatingSystem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Coat {
        data = typeof data === 'object' ? data : {};
        let result = new Coat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coatNameId"] = this.coatNameId;
        data["coatName"] = this.coatName ? this.coatName.toJSON() : <any>undefined;
        data["genericClassification"] = this.genericClassification;
        data["dft"] = this.dft;
        data["notes"] = this.notes;
        data["coatingSystemId"] = this.coatingSystemId;
        data["coatingSystem"] = this.coatingSystem ? this.coatingSystem.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoat {
    id?: string;
    coatNameId?: string | undefined;
    coatName?: CoatName;
    genericClassification?: string | undefined;
    dft?: string | undefined;
    notes?: string | undefined;
    coatingSystemId: string;
    coatingSystem?: CoatingSystem;
}

export class CoatName implements ICoatName {
    id?: string | undefined;
    relativeOrder?: number;

    constructor(data?: ICoatName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.relativeOrder = _data["relativeOrder"];
        }
    }

    static fromJS(data: any): CoatName {
        data = typeof data === 'object' ? data : {};
        let result = new CoatName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["relativeOrder"] = this.relativeOrder;
        return data;
    }
}

export interface ICoatName {
    id?: string | undefined;
    relativeOrder?: number;
}

export class CoatingProduct implements ICoatingProduct {
    id?: string;
    name?: string | undefined;
    manufacturerId!: number;
    manufacturer?: Manufacturer;
    coatingProductProperties?: CoatingProductProperty[] | undefined;
    productServiceTemperatures?: ProductServiceTemperature[] | undefined;
    fromRevisionId?: number;
    fromRevision?: CoatingRevision;
    toRevisionId?: number;
    prevRevisionProdId?: string | undefined;
    technologyStandards?: TechnologyStandard[] | undefined;

    constructor(data?: ICoatingProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.manufacturerId = _data["manufacturerId"];
            this.manufacturer = _data["manufacturer"] ? Manufacturer.fromJS(_data["manufacturer"]) : <any>undefined;
            if (Array.isArray(_data["coatingProductProperties"])) {
                this.coatingProductProperties = [] as any;
                for (let item of _data["coatingProductProperties"])
                    this.coatingProductProperties!.push(CoatingProductProperty.fromJS(item));
            }
            if (Array.isArray(_data["productServiceTemperatures"])) {
                this.productServiceTemperatures = [] as any;
                for (let item of _data["productServiceTemperatures"])
                    this.productServiceTemperatures!.push(ProductServiceTemperature.fromJS(item));
            }
            this.fromRevisionId = _data["fromRevisionId"];
            this.fromRevision = _data["fromRevision"] ? CoatingRevision.fromJS(_data["fromRevision"]) : <any>undefined;
            this.toRevisionId = _data["toRevisionId"];
            this.prevRevisionProdId = _data["prevRevisionProdId"];
            if (Array.isArray(_data["technologyStandards"])) {
                this.technologyStandards = [] as any;
                for (let item of _data["technologyStandards"])
                    this.technologyStandards!.push(TechnologyStandard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoatingProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["manufacturerId"] = this.manufacturerId;
        data["manufacturer"] = this.manufacturer ? this.manufacturer.toJSON() : <any>undefined;
        if (Array.isArray(this.coatingProductProperties)) {
            data["coatingProductProperties"] = [];
            for (let item of this.coatingProductProperties)
                data["coatingProductProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.productServiceTemperatures)) {
            data["productServiceTemperatures"] = [];
            for (let item of this.productServiceTemperatures)
                data["productServiceTemperatures"].push(item.toJSON());
        }
        data["fromRevisionId"] = this.fromRevisionId;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["toRevisionId"] = this.toRevisionId;
        data["prevRevisionProdId"] = this.prevRevisionProdId;
        if (Array.isArray(this.technologyStandards)) {
            data["technologyStandards"] = [];
            for (let item of this.technologyStandards)
                data["technologyStandards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoatingProduct {
    id?: string;
    name?: string | undefined;
    manufacturerId: number;
    manufacturer?: Manufacturer;
    coatingProductProperties?: CoatingProductProperty[] | undefined;
    productServiceTemperatures?: ProductServiceTemperature[] | undefined;
    fromRevisionId?: number;
    fromRevision?: CoatingRevision;
    toRevisionId?: number;
    prevRevisionProdId?: string | undefined;
    technologyStandards?: TechnologyStandard[] | undefined;
}

export class CoatingProductProperty implements ICoatingProductProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    coatingProductId!: string;
    updateAt?: Date;

    constructor(data?: ICoatingProductProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.coatingProductId = _data["coatingProductId"];
            this.updateAt = _data["updateAt"] ? new Date(_data["updateAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CoatingProductProperty {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingProductProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["coatingProductId"] = this.coatingProductId;
        data["updateAt"] = this.updateAt ? this.updateAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICoatingProductProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    coatingProductId: string;
    updateAt?: Date;
}

export class CoatingRevision implements ICoatingRevision {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    publishDate?: Date;
    authorOid?: string;
    technologyStandardId?: string | undefined;
    technologyStandard?: TechnologyStandard;
    status?: RevisionStatus;
    isMajor?: boolean;
    major?: number;
    minor?: number;
    approvals?: RevisionApproval[] | undefined;
    comments?: RevisionComment[] | undefined;
    coatingSystemSolutions?: CoatingSystemSolution[] | undefined;
    coatingSystems?: CoatingSystem[] | undefined;
    coatingProducts?: CoatingProduct[] | undefined;
    coatingRevisionItemArchives?: CoatingRevisionItemArchive[] | undefined;

    constructor(data?: ICoatingRevision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.authorOid = _data["authorOid"];
            this.technologyStandardId = _data["technologyStandardId"];
            this.technologyStandard = _data["technologyStandard"] ? TechnologyStandard.fromJS(_data["technologyStandard"]) : <any>undefined;
            this.status = _data["status"];
            this.isMajor = _data["isMajor"];
            this.major = _data["major"];
            this.minor = _data["minor"];
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(RevisionApproval.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(RevisionComment.fromJS(item));
            }
            if (Array.isArray(_data["coatingSystemSolutions"])) {
                this.coatingSystemSolutions = [] as any;
                for (let item of _data["coatingSystemSolutions"])
                    this.coatingSystemSolutions!.push(CoatingSystemSolution.fromJS(item));
            }
            if (Array.isArray(_data["coatingSystems"])) {
                this.coatingSystems = [] as any;
                for (let item of _data["coatingSystems"])
                    this.coatingSystems!.push(CoatingSystem.fromJS(item));
            }
            if (Array.isArray(_data["coatingProducts"])) {
                this.coatingProducts = [] as any;
                for (let item of _data["coatingProducts"])
                    this.coatingProducts!.push(CoatingProduct.fromJS(item));
            }
            if (Array.isArray(_data["coatingRevisionItemArchives"])) {
                this.coatingRevisionItemArchives = [] as any;
                for (let item of _data["coatingRevisionItemArchives"])
                    this.coatingRevisionItemArchives!.push(CoatingRevisionItemArchive.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoatingRevision {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingRevision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["authorOid"] = this.authorOid;
        data["technologyStandardId"] = this.technologyStandardId;
        data["technologyStandard"] = this.technologyStandard ? this.technologyStandard.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isMajor"] = this.isMajor;
        data["major"] = this.major;
        data["minor"] = this.minor;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingSystemSolutions)) {
            data["coatingSystemSolutions"] = [];
            for (let item of this.coatingSystemSolutions)
                data["coatingSystemSolutions"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingSystems)) {
            data["coatingSystems"] = [];
            for (let item of this.coatingSystems)
                data["coatingSystems"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingProducts)) {
            data["coatingProducts"] = [];
            for (let item of this.coatingProducts)
                data["coatingProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingRevisionItemArchives)) {
            data["coatingRevisionItemArchives"] = [];
            for (let item of this.coatingRevisionItemArchives)
                data["coatingRevisionItemArchives"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoatingRevision {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    publishDate?: Date;
    authorOid?: string;
    technologyStandardId?: string | undefined;
    technologyStandard?: TechnologyStandard;
    status?: RevisionStatus;
    isMajor?: boolean;
    major?: number;
    minor?: number;
    approvals?: RevisionApproval[] | undefined;
    comments?: RevisionComment[] | undefined;
    coatingSystemSolutions?: CoatingSystemSolution[] | undefined;
    coatingSystems?: CoatingSystem[] | undefined;
    coatingProducts?: CoatingProduct[] | undefined;
    coatingRevisionItemArchives?: CoatingRevisionItemArchive[] | undefined;
}

export class CoatingRevisionItemArchive implements ICoatingRevisionItemArchive {
    itemId?: string;
    coatingRevisionId?: number;
    coatingRevision?: CoatingRevision;
    itemType!: RevisionItemType;

    constructor(data?: ICoatingRevisionItemArchive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.coatingRevisionId = _data["coatingRevisionId"];
            this.coatingRevision = _data["coatingRevision"] ? CoatingRevision.fromJS(_data["coatingRevision"]) : <any>undefined;
            this.itemType = _data["itemType"];
        }
    }

    static fromJS(data: any): CoatingRevisionItemArchive {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingRevisionItemArchive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["coatingRevisionId"] = this.coatingRevisionId;
        data["coatingRevision"] = this.coatingRevision ? this.coatingRevision.toJSON() : <any>undefined;
        data["itemType"] = this.itemType;
        return data;
    }
}

export interface ICoatingRevisionItemArchive {
    itemId?: string;
    coatingRevisionId?: number;
    coatingRevision?: CoatingRevision;
    itemType: RevisionItemType;
}

export class CoatingSystem implements ICoatingSystem {
    id?: string;
    coatingSystemId?: string | undefined;
    name?: string | undefined;
    coatingSystemCategoryName!: string;
    coatingSystemCategory?: CoatingSystemCategory;
    coatingSystemTypeName?: string | undefined;
    coatingSystemType?: CoatingSystemType;
    technologyStandardId!: string;
    technologyStandard?: TechnologyStandard;
    serviceId?: string;
    service?: Service;
    properties?: CoatingSystemProperty[] | undefined;
    fromRevisionId?: number;
    fromRevision?: CoatingRevision;
    toRevisionId?: number;
    coats?: Coat[] | undefined;
    prevRevisionSystemId?: string | undefined;

    constructor(data?: ICoatingSystem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coatingSystemId = _data["coatingSystemId"];
            this.name = _data["name"];
            this.coatingSystemCategoryName = _data["coatingSystemCategoryName"];
            this.coatingSystemCategory = _data["coatingSystemCategory"] ? CoatingSystemCategory.fromJS(_data["coatingSystemCategory"]) : <any>undefined;
            this.coatingSystemTypeName = _data["coatingSystemTypeName"];
            this.coatingSystemType = _data["coatingSystemType"] ? CoatingSystemType.fromJS(_data["coatingSystemType"]) : <any>undefined;
            this.technologyStandardId = _data["technologyStandardId"];
            this.technologyStandard = _data["technologyStandard"] ? TechnologyStandard.fromJS(_data["technologyStandard"]) : <any>undefined;
            this.serviceId = _data["serviceId"];
            this.service = _data["service"] ? Service.fromJS(_data["service"]) : <any>undefined;
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(CoatingSystemProperty.fromJS(item));
            }
            this.fromRevisionId = _data["fromRevisionId"];
            this.fromRevision = _data["fromRevision"] ? CoatingRevision.fromJS(_data["fromRevision"]) : <any>undefined;
            this.toRevisionId = _data["toRevisionId"];
            if (Array.isArray(_data["coats"])) {
                this.coats = [] as any;
                for (let item of _data["coats"])
                    this.coats!.push(Coat.fromJS(item));
            }
            this.prevRevisionSystemId = _data["prevRevisionSystemId"];
        }
    }

    static fromJS(data: any): CoatingSystem {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coatingSystemId"] = this.coatingSystemId;
        data["name"] = this.name;
        data["coatingSystemCategoryName"] = this.coatingSystemCategoryName;
        data["coatingSystemCategory"] = this.coatingSystemCategory ? this.coatingSystemCategory.toJSON() : <any>undefined;
        data["coatingSystemTypeName"] = this.coatingSystemTypeName;
        data["coatingSystemType"] = this.coatingSystemType ? this.coatingSystemType.toJSON() : <any>undefined;
        data["technologyStandardId"] = this.technologyStandardId;
        data["technologyStandard"] = this.technologyStandard ? this.technologyStandard.toJSON() : <any>undefined;
        data["serviceId"] = this.serviceId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["fromRevisionId"] = this.fromRevisionId;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["toRevisionId"] = this.toRevisionId;
        if (Array.isArray(this.coats)) {
            data["coats"] = [];
            for (let item of this.coats)
                data["coats"].push(item.toJSON());
        }
        data["prevRevisionSystemId"] = this.prevRevisionSystemId;
        return data;
    }
}

export interface ICoatingSystem {
    id?: string;
    coatingSystemId?: string | undefined;
    name?: string | undefined;
    coatingSystemCategoryName: string;
    coatingSystemCategory?: CoatingSystemCategory;
    coatingSystemTypeName?: string | undefined;
    coatingSystemType?: CoatingSystemType;
    technologyStandardId: string;
    technologyStandard?: TechnologyStandard;
    serviceId?: string;
    service?: Service;
    properties?: CoatingSystemProperty[] | undefined;
    fromRevisionId?: number;
    fromRevision?: CoatingRevision;
    toRevisionId?: number;
    coats?: Coat[] | undefined;
    prevRevisionSystemId?: string | undefined;
}

export class CoatingSystemCategory implements ICoatingSystemCategory {
    name?: string | undefined;
    order?: number;
    readonly coatingSystems?: CoatingSystem[] | undefined;

    constructor(data?: ICoatingSystemCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            if (Array.isArray(_data["coatingSystems"])) {
                (<any>this).coatingSystems = [] as any;
                for (let item of _data["coatingSystems"])
                    (<any>this).coatingSystems!.push(CoatingSystem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoatingSystemCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystemCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        if (Array.isArray(this.coatingSystems)) {
            data["coatingSystems"] = [];
            for (let item of this.coatingSystems)
                data["coatingSystems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoatingSystemCategory {
    name?: string | undefined;
    order?: number;
    coatingSystems?: CoatingSystem[] | undefined;
}

export class CoatingSystemProperty implements ICoatingSystemProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    coatingSystemId!: string;
    coatingSystem?: CoatingSystem;

    constructor(data?: ICoatingSystemProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.coatingSystemId = _data["coatingSystemId"];
            this.coatingSystem = _data["coatingSystem"] ? CoatingSystem.fromJS(_data["coatingSystem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CoatingSystemProperty {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystemProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["coatingSystemId"] = this.coatingSystemId;
        data["coatingSystem"] = this.coatingSystem ? this.coatingSystem.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoatingSystemProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    coatingSystemId: string;
    coatingSystem?: CoatingSystem;
}

export class CoatingSystemSolution implements ICoatingSystemSolution {
    id?: string;
    name?: string | undefined;
    notes?: string | undefined;
    coatingSystemId!: string;
    coatingSystem?: CoatingSystem;
    coatingSystemSolutionCoats?: CoatingSystemSolutionCoat[] | undefined;
    fromRevisionId?: number;
    fromRevision?: CoatingRevision;
    toRevisionId?: number;
    prevRevisionSolutionId?: string | undefined;

    constructor(data?: ICoatingSystemSolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.coatingSystemId = _data["coatingSystemId"];
            this.coatingSystem = _data["coatingSystem"] ? CoatingSystem.fromJS(_data["coatingSystem"]) : <any>undefined;
            if (Array.isArray(_data["coatingSystemSolutionCoats"])) {
                this.coatingSystemSolutionCoats = [] as any;
                for (let item of _data["coatingSystemSolutionCoats"])
                    this.coatingSystemSolutionCoats!.push(CoatingSystemSolutionCoat.fromJS(item));
            }
            this.fromRevisionId = _data["fromRevisionId"];
            this.fromRevision = _data["fromRevision"] ? CoatingRevision.fromJS(_data["fromRevision"]) : <any>undefined;
            this.toRevisionId = _data["toRevisionId"];
            this.prevRevisionSolutionId = _data["prevRevisionSolutionId"];
        }
    }

    static fromJS(data: any): CoatingSystemSolution {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystemSolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["coatingSystemId"] = this.coatingSystemId;
        data["coatingSystem"] = this.coatingSystem ? this.coatingSystem.toJSON() : <any>undefined;
        if (Array.isArray(this.coatingSystemSolutionCoats)) {
            data["coatingSystemSolutionCoats"] = [];
            for (let item of this.coatingSystemSolutionCoats)
                data["coatingSystemSolutionCoats"].push(item.toJSON());
        }
        data["fromRevisionId"] = this.fromRevisionId;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["toRevisionId"] = this.toRevisionId;
        data["prevRevisionSolutionId"] = this.prevRevisionSolutionId;
        return data;
    }
}

export interface ICoatingSystemSolution {
    id?: string;
    name?: string | undefined;
    notes?: string | undefined;
    coatingSystemId: string;
    coatingSystem?: CoatingSystem;
    coatingSystemSolutionCoats?: CoatingSystemSolutionCoat[] | undefined;
    fromRevisionId?: number;
    fromRevision?: CoatingRevision;
    toRevisionId?: number;
    prevRevisionSolutionId?: string | undefined;
}

export class CoatingSystemSolutionCoat implements ICoatingSystemSolutionCoat {
    id?: string;
    coatingSystemSolutionId?: string;
    coatingProductId?: string;
    coatingProduct?: CoatingProduct;
    coatId!: string;
    coat?: Coat;

    constructor(data?: ICoatingSystemSolutionCoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coatingSystemSolutionId = _data["coatingSystemSolutionId"];
            this.coatingProductId = _data["coatingProductId"];
            this.coatingProduct = _data["coatingProduct"] ? CoatingProduct.fromJS(_data["coatingProduct"]) : <any>undefined;
            this.coatId = _data["coatId"];
            this.coat = _data["coat"] ? Coat.fromJS(_data["coat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CoatingSystemSolutionCoat {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystemSolutionCoat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coatingSystemSolutionId"] = this.coatingSystemSolutionId;
        data["coatingProductId"] = this.coatingProductId;
        data["coatingProduct"] = this.coatingProduct ? this.coatingProduct.toJSON() : <any>undefined;
        data["coatId"] = this.coatId;
        data["coat"] = this.coat ? this.coat.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoatingSystemSolutionCoat {
    id?: string;
    coatingSystemSolutionId?: string;
    coatingProductId?: string;
    coatingProduct?: CoatingProduct;
    coatId: string;
    coat?: Coat;
}

export class CoatingSystemType implements ICoatingSystemType {
    name?: string | undefined;
    order?: number;
    readonly coatingSystems?: CoatingSystem[] | undefined;

    constructor(data?: ICoatingSystemType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            if (Array.isArray(_data["coatingSystems"])) {
                (<any>this).coatingSystems = [] as any;
                for (let item of _data["coatingSystems"])
                    (<any>this).coatingSystems!.push(CoatingSystem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoatingSystemType {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystemType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        if (Array.isArray(this.coatingSystems)) {
            data["coatingSystems"] = [];
            for (let item of this.coatingSystems)
                data["coatingSystems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoatingSystemType {
    name?: string | undefined;
    order?: number;
    coatingSystems?: CoatingSystem[] | undefined;
}

export class Manufacturer implements IManufacturer {
    id?: number;
    name?: string | undefined;

    constructor(data?: IManufacturer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Manufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new Manufacturer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IManufacturer {
    id?: number;
    name?: string | undefined;
}

export class ProductServiceTemperature implements IProductServiceTemperature {
    id?: string;
    serviceId?: string;
    service?: Service;
    coatingProductId?: string;
    coatingProduct?: CoatingProduct;
    serviceTempMaxC?: string | undefined;

    constructor(data?: IProductServiceTemperature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.service = _data["service"] ? Service.fromJS(_data["service"]) : <any>undefined;
            this.coatingProductId = _data["coatingProductId"];
            this.coatingProduct = _data["coatingProduct"] ? CoatingProduct.fromJS(_data["coatingProduct"]) : <any>undefined;
            this.serviceTempMaxC = _data["serviceTempMaxC"];
        }
    }

    static fromJS(data: any): ProductServiceTemperature {
        data = typeof data === 'object' ? data : {};
        let result = new ProductServiceTemperature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["coatingProductId"] = this.coatingProductId;
        data["coatingProduct"] = this.coatingProduct ? this.coatingProduct.toJSON() : <any>undefined;
        data["serviceTempMaxC"] = this.serviceTempMaxC;
        return data;
    }
}

export interface IProductServiceTemperature {
    id?: string;
    serviceId?: string;
    service?: Service;
    coatingProductId?: string;
    coatingProduct?: CoatingProduct;
    serviceTempMaxC?: string | undefined;
}

export class RevisionApproval implements IRevisionApproval {
    id?: number;
    coatingRevisionId?: number;
    coatingRevision?: CoatingRevision;
    approverOid!: string;
    status?: RevisionApprovalStatus;
    approverType?: ApproverType;
    dueDate?: Date;
    updatedAt?: Date;

    constructor(data?: IRevisionApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coatingRevisionId = _data["coatingRevisionId"];
            this.coatingRevision = _data["coatingRevision"] ? CoatingRevision.fromJS(_data["coatingRevision"]) : <any>undefined;
            this.approverOid = _data["approverOid"];
            this.status = _data["status"];
            this.approverType = _data["approverType"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RevisionApproval {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coatingRevisionId"] = this.coatingRevisionId;
        data["coatingRevision"] = this.coatingRevision ? this.coatingRevision.toJSON() : <any>undefined;
        data["approverOid"] = this.approverOid;
        data["status"] = this.status;
        data["approverType"] = this.approverType;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRevisionApproval {
    id?: number;
    coatingRevisionId?: number;
    coatingRevision?: CoatingRevision;
    approverOid: string;
    status?: RevisionApprovalStatus;
    approverType?: ApproverType;
    dueDate?: Date;
    updatedAt?: Date;
}

export enum RevisionApprovalStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RevisionComment implements IRevisionComment {
    id?: number;
    comment?: string | undefined;
    coatingRevisionId?: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    parentComment?: RevisionComment;
    linkedCoatingSystemId?: string | undefined;
    linkedCoatingProductId?: string | undefined;
    linkedCoatingSystemSolutionId?: string | undefined;
    replies?: RevisionComment[] | undefined;

    constructor(data?: IRevisionComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.coatingRevisionId = _data["coatingRevisionId"];
            this.createdByOid = _data["createdByOid"];
            this.updatedByOid = _data["updatedByOid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.parentCommentId = _data["parentCommentId"];
            this.parentComment = _data["parentComment"] ? RevisionComment.fromJS(_data["parentComment"]) : <any>undefined;
            this.linkedCoatingSystemId = _data["linkedCoatingSystemId"];
            this.linkedCoatingProductId = _data["linkedCoatingProductId"];
            this.linkedCoatingSystemSolutionId = _data["linkedCoatingSystemSolutionId"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [] as any;
                for (let item of _data["replies"])
                    this.replies!.push(RevisionComment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionComment {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["coatingRevisionId"] = this.coatingRevisionId;
        data["createdByOid"] = this.createdByOid;
        data["updatedByOid"] = this.updatedByOid;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["parentCommentId"] = this.parentCommentId;
        data["parentComment"] = this.parentComment ? this.parentComment.toJSON() : <any>undefined;
        data["linkedCoatingSystemId"] = this.linkedCoatingSystemId;
        data["linkedCoatingProductId"] = this.linkedCoatingProductId;
        data["linkedCoatingSystemSolutionId"] = this.linkedCoatingSystemSolutionId;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (let item of this.replies)
                data["replies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRevisionComment {
    id?: number;
    comment?: string | undefined;
    coatingRevisionId?: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    parentComment?: RevisionComment;
    linkedCoatingSystemId?: string | undefined;
    linkedCoatingProductId?: string | undefined;
    linkedCoatingSystemSolutionId?: string | undefined;
    replies?: RevisionComment[] | undefined;
}

export enum RevisionCommentStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum RevisionItemType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Service implements IService {
    id?: string;
    serviceName?: string | undefined;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceName = _data["serviceName"];
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceName"] = this.serviceName;
        return data;
    }
}

export interface IService {
    id?: string;
    serviceName?: string | undefined;
}

export class Technology implements ITechnology {
    id!: string;
    technologyName?: string | undefined;

    constructor(data?: ITechnology) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.technologyName = _data["technologyName"];
        }
    }

    static fromJS(data: any): Technology {
        data = typeof data === 'object' ? data : {};
        let result = new Technology();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["technologyName"] = this.technologyName;
        return data;
    }
}

export interface ITechnology {
    id: string;
    technologyName?: string | undefined;
}

export class TechnologyStandard implements ITechnologyStandard {
    id?: string | undefined;
    technologyId!: string;
    technology?: Technology;
    technologyStandardName?: string | undefined;
    coatingProducts?: CoatingProduct[] | undefined;

    constructor(data?: ITechnologyStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.technologyId = _data["technologyId"];
            this.technology = _data["technology"] ? Technology.fromJS(_data["technology"]) : <any>undefined;
            this.technologyStandardName = _data["technologyStandardName"];
            if (Array.isArray(_data["coatingProducts"])) {
                this.coatingProducts = [] as any;
                for (let item of _data["coatingProducts"])
                    this.coatingProducts!.push(CoatingProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TechnologyStandard {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["technologyId"] = this.technologyId;
        data["technology"] = this.technology ? this.technology.toJSON() : <any>undefined;
        data["technologyStandardName"] = this.technologyStandardName;
        if (Array.isArray(this.coatingProducts)) {
            data["coatingProducts"] = [];
            for (let item of this.coatingProducts)
                data["coatingProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITechnologyStandard {
    id?: string | undefined;
    technologyId: string;
    technology?: Technology;
    technologyStandardName?: string | undefined;
    coatingProducts?: CoatingProduct[] | undefined;
}

export class CoatViewModel implements ICoatViewModel {
    id?: string;
    coatName?: string | undefined;
    coatRelativeOrder?: number;
    genericClassification?: string | undefined;
    dft?: string | undefined;
    notes?: string | undefined;
    coatingSystemId?: string;

    constructor(data?: ICoatViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coatName = _data["coatName"];
            this.coatRelativeOrder = _data["coatRelativeOrder"];
            this.genericClassification = _data["genericClassification"];
            this.dft = _data["dft"];
            this.notes = _data["notes"];
            this.coatingSystemId = _data["coatingSystemId"];
        }
    }

    static fromJS(data: any): CoatViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoatViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coatName"] = this.coatName;
        data["coatRelativeOrder"] = this.coatRelativeOrder;
        data["genericClassification"] = this.genericClassification;
        data["dft"] = this.dft;
        data["notes"] = this.notes;
        data["coatingSystemId"] = this.coatingSystemId;
        return data;
    }
}

export interface ICoatViewModel {
    id?: string;
    coatName?: string | undefined;
    coatRelativeOrder?: number;
    genericClassification?: string | undefined;
    dft?: string | undefined;
    notes?: string | undefined;
    coatingSystemId?: string;
}

export class CoatingProductMinimalViewModel implements ICoatingProductMinimalViewModel {
    coatingProductId?: string;
    name!: string;
    manufacturer!: string;
    allowedServices?: string[] | undefined;

    constructor(data?: ICoatingProductMinimalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coatingProductId = _data["coatingProductId"];
            this.name = _data["name"];
            this.manufacturer = _data["manufacturer"];
            if (Array.isArray(_data["allowedServices"])) {
                this.allowedServices = [] as any;
                for (let item of _data["allowedServices"])
                    this.allowedServices!.push(item);
            }
        }
    }

    static fromJS(data: any): CoatingProductMinimalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingProductMinimalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coatingProductId"] = this.coatingProductId;
        data["name"] = this.name;
        data["manufacturer"] = this.manufacturer;
        if (Array.isArray(this.allowedServices)) {
            data["allowedServices"] = [];
            for (let item of this.allowedServices)
                data["allowedServices"].push(item);
        }
        return data;
    }
}

export interface ICoatingProductMinimalViewModel {
    coatingProductId?: string;
    name: string;
    manufacturer: string;
    allowedServices?: string[] | undefined;
}

export class CoatingProductViewModel implements ICoatingProductViewModel {
    coatingProductId?: string;
    name!: string;
    manufacturer!: string;
    serviceTempMaxC?: string | undefined;
    serviceTempMinC?: string | undefined;
    dft?: string | undefined;
    steamOutC?: string | undefined;
    minGramsPerLiterVOC?: string | undefined;
    maxGramsPerLiterVOC?: string | undefined;
    cureToImmersion?: string | undefined;
    productNotes?: string | undefined;
    liningType?: string | undefined;
    productServiceTemperatures?: ProductServiceTemperatureViewModel[] | undefined;
    prevRevisionProdId?: string | undefined;

    constructor(data?: ICoatingProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coatingProductId = _data["coatingProductId"];
            this.name = _data["name"];
            this.manufacturer = _data["manufacturer"];
            this.serviceTempMaxC = _data["serviceTempMaxC"];
            this.serviceTempMinC = _data["serviceTempMinC"];
            this.dft = _data["dft"];
            this.steamOutC = _data["steamOutC"];
            this.minGramsPerLiterVOC = _data["minGramsPerLiterVOC"];
            this.maxGramsPerLiterVOC = _data["maxGramsPerLiterVOC"];
            this.cureToImmersion = _data["cureToImmersion"];
            this.productNotes = _data["productNotes"];
            this.liningType = _data["liningType"];
            if (Array.isArray(_data["productServiceTemperatures"])) {
                this.productServiceTemperatures = [] as any;
                for (let item of _data["productServiceTemperatures"])
                    this.productServiceTemperatures!.push(ProductServiceTemperatureViewModel.fromJS(item));
            }
            this.prevRevisionProdId = _data["prevRevisionProdId"];
        }
    }

    static fromJS(data: any): CoatingProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coatingProductId"] = this.coatingProductId;
        data["name"] = this.name;
        data["manufacturer"] = this.manufacturer;
        data["serviceTempMaxC"] = this.serviceTempMaxC;
        data["serviceTempMinC"] = this.serviceTempMinC;
        data["dft"] = this.dft;
        data["steamOutC"] = this.steamOutC;
        data["minGramsPerLiterVOC"] = this.minGramsPerLiterVOC;
        data["maxGramsPerLiterVOC"] = this.maxGramsPerLiterVOC;
        data["cureToImmersion"] = this.cureToImmersion;
        data["productNotes"] = this.productNotes;
        data["liningType"] = this.liningType;
        if (Array.isArray(this.productServiceTemperatures)) {
            data["productServiceTemperatures"] = [];
            for (let item of this.productServiceTemperatures)
                data["productServiceTemperatures"].push(item.toJSON());
        }
        data["prevRevisionProdId"] = this.prevRevisionProdId;
        return data;
    }
}

export interface ICoatingProductViewModel {
    coatingProductId?: string;
    name: string;
    manufacturer: string;
    serviceTempMaxC?: string | undefined;
    serviceTempMinC?: string | undefined;
    dft?: string | undefined;
    steamOutC?: string | undefined;
    minGramsPerLiterVOC?: string | undefined;
    maxGramsPerLiterVOC?: string | undefined;
    cureToImmersion?: string | undefined;
    productNotes?: string | undefined;
    liningType?: string | undefined;
    productServiceTemperatures?: ProductServiceTemperatureViewModel[] | undefined;
    prevRevisionProdId?: string | undefined;
}

export class CoatingRevisionViewModel implements ICoatingRevisionViewModel {
    id?: number;
    name!: string;
    description!: string;
    publishDate?: Date;
    authorOid?: string;
    technologyStandardId!: string;
    technologyStandard?: TechnologyStandard;
    status?: RevisionStatus;
    isMajor!: boolean;
    major?: number;
    minor?: number;
    reviewDueDate?: Date | undefined;
    approvals?: RevisionApprovalViewModel[] | undefined;
    comments?: RevisionCommentViewModel[] | undefined;
    coatingSystemSolutions?: SimpleObjectViewModel[] | undefined;
    coatingSystems?: SimpleObjectViewModel[] | undefined;
    coatingProducts?: SimpleObjectViewModel[] | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ICoatingRevisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.authorOid = _data["authorOid"];
            this.technologyStandardId = _data["technologyStandardId"];
            this.technologyStandard = _data["technologyStandard"] ? TechnologyStandard.fromJS(_data["technologyStandard"]) : <any>undefined;
            this.status = _data["status"];
            this.isMajor = _data["isMajor"];
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.reviewDueDate = _data["reviewDueDate"] ? new Date(_data["reviewDueDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(RevisionApprovalViewModel.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(RevisionCommentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["coatingSystemSolutions"])) {
                this.coatingSystemSolutions = [] as any;
                for (let item of _data["coatingSystemSolutions"])
                    this.coatingSystemSolutions!.push(SimpleObjectViewModel.fromJS(item));
            }
            if (Array.isArray(_data["coatingSystems"])) {
                this.coatingSystems = [] as any;
                for (let item of _data["coatingSystems"])
                    this.coatingSystems!.push(SimpleObjectViewModel.fromJS(item));
            }
            if (Array.isArray(_data["coatingProducts"])) {
                this.coatingProducts = [] as any;
                for (let item of _data["coatingProducts"])
                    this.coatingProducts!.push(SimpleObjectViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CoatingRevisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingRevisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["authorOid"] = this.authorOid;
        data["technologyStandardId"] = this.technologyStandardId;
        data["technologyStandard"] = this.technologyStandard ? this.technologyStandard.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isMajor"] = this.isMajor;
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["reviewDueDate"] = this.reviewDueDate ? this.reviewDueDate.toISOString() : <any>undefined;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingSystemSolutions)) {
            data["coatingSystemSolutions"] = [];
            for (let item of this.coatingSystemSolutions)
                data["coatingSystemSolutions"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingSystems)) {
            data["coatingSystems"] = [];
            for (let item of this.coatingSystems)
                data["coatingSystems"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingProducts)) {
            data["coatingProducts"] = [];
            for (let item of this.coatingProducts)
                data["coatingProducts"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICoatingRevisionViewModel {
    id?: number;
    name: string;
    description: string;
    publishDate?: Date;
    authorOid?: string;
    technologyStandardId: string;
    technologyStandard?: TechnologyStandard;
    status?: RevisionStatus;
    isMajor: boolean;
    major?: number;
    minor?: number;
    reviewDueDate?: Date | undefined;
    approvals?: RevisionApprovalViewModel[] | undefined;
    comments?: RevisionCommentViewModel[] | undefined;
    coatingSystemSolutions?: SimpleObjectViewModel[] | undefined;
    coatingSystems?: SimpleObjectViewModel[] | undefined;
    coatingProducts?: SimpleObjectViewModel[] | undefined;
    errorMessage?: string | undefined;
}

export class CoatingSolutionProducts implements ICoatingSolutionProducts {
    productName?: string | undefined;
    coatingProductId?: string | undefined;
    coatName?: string | undefined;
    coatId?: string | undefined;

    constructor(data?: ICoatingSolutionProducts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.coatingProductId = _data["coatingProductId"];
            this.coatName = _data["coatName"];
            this.coatId = _data["coatId"];
        }
    }

    static fromJS(data: any): CoatingSolutionProducts {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSolutionProducts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["coatingProductId"] = this.coatingProductId;
        data["coatName"] = this.coatName;
        data["coatId"] = this.coatId;
        return data;
    }
}

export interface ICoatingSolutionProducts {
    productName?: string | undefined;
    coatingProductId?: string | undefined;
    coatName?: string | undefined;
    coatId?: string | undefined;
}

export class CoatingSystemSolutionViewModel implements ICoatingSystemSolutionViewModel {
    solutionId?: string;
    solutionName?: string | undefined;
    notes?: string | undefined;
    fromRevision?: number;
    manufacturer?: string | undefined;
    serviceTempMaxC?: number;
    minGramsPerLiterVOC?: number;
    maxGramsPerLiterVOC?: number;
    toRevisionId?: number;
    prevRevisionSolutionId?: string | undefined;
    coatingSystem?: CoatingSystemViewModel;
    coats?: SolutionCoat[] | undefined;
    coatingSolutionProducts?: CoatingSolutionProducts[] | undefined;

    constructor(data?: ICoatingSystemSolutionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solutionId = _data["solutionId"];
            this.solutionName = _data["solutionName"];
            this.notes = _data["notes"];
            this.fromRevision = _data["fromRevision"];
            this.manufacturer = _data["manufacturer"];
            this.serviceTempMaxC = _data["serviceTempMaxC"];
            this.minGramsPerLiterVOC = _data["minGramsPerLiterVOC"];
            this.maxGramsPerLiterVOC = _data["maxGramsPerLiterVOC"];
            this.toRevisionId = _data["toRevisionId"];
            this.prevRevisionSolutionId = _data["prevRevisionSolutionId"];
            this.coatingSystem = _data["coatingSystem"] ? CoatingSystemViewModel.fromJS(_data["coatingSystem"]) : <any>undefined;
            if (Array.isArray(_data["coats"])) {
                this.coats = [] as any;
                for (let item of _data["coats"])
                    this.coats!.push(SolutionCoat.fromJS(item));
            }
            if (Array.isArray(_data["coatingSolutionProducts"])) {
                this.coatingSolutionProducts = [] as any;
                for (let item of _data["coatingSolutionProducts"])
                    this.coatingSolutionProducts!.push(CoatingSolutionProducts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoatingSystemSolutionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystemSolutionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solutionId"] = this.solutionId;
        data["solutionName"] = this.solutionName;
        data["notes"] = this.notes;
        data["fromRevision"] = this.fromRevision;
        data["manufacturer"] = this.manufacturer;
        data["serviceTempMaxC"] = this.serviceTempMaxC;
        data["minGramsPerLiterVOC"] = this.minGramsPerLiterVOC;
        data["maxGramsPerLiterVOC"] = this.maxGramsPerLiterVOC;
        data["toRevisionId"] = this.toRevisionId;
        data["prevRevisionSolutionId"] = this.prevRevisionSolutionId;
        data["coatingSystem"] = this.coatingSystem ? this.coatingSystem.toJSON() : <any>undefined;
        if (Array.isArray(this.coats)) {
            data["coats"] = [];
            for (let item of this.coats)
                data["coats"].push(item.toJSON());
        }
        if (Array.isArray(this.coatingSolutionProducts)) {
            data["coatingSolutionProducts"] = [];
            for (let item of this.coatingSolutionProducts)
                data["coatingSolutionProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoatingSystemSolutionViewModel {
    solutionId?: string;
    solutionName?: string | undefined;
    notes?: string | undefined;
    fromRevision?: number;
    manufacturer?: string | undefined;
    serviceTempMaxC?: number;
    minGramsPerLiterVOC?: number;
    maxGramsPerLiterVOC?: number;
    toRevisionId?: number;
    prevRevisionSolutionId?: string | undefined;
    coatingSystem?: CoatingSystemViewModel;
    coats?: SolutionCoat[] | undefined;
    coatingSolutionProducts?: CoatingSolutionProducts[] | undefined;
}

export class CoatingSystemViewModel implements ICoatingSystemViewModel {
    id?: string;
    coatingSystemId!: string;
    name!: string;
    coatingSystemCategory!: string;
    technologyStandard!: string;
    technologyStandardName?: string | undefined;
    service!: string;
    vocCategory?: string | undefined;
    coatingSystemType?: string | undefined;
    surfacePrep?: string | undefined;
    anchorPattern?: string | undefined;
    totalDFT?: string | undefined;
    touchUp?: string | undefined;
    coatingSystemNotes?: string | undefined;
    substrateMaterial?: string[] | undefined;
    equipmentGroup?: string[] | undefined;
    equipmentDescription?: string[] | undefined;
    physicalAbuse?: string | undefined;
    applicationEnvironment?: string[] | undefined;
    exposureCycle?: string[] | undefined;
    exposureToTemperature?: string | undefined;
    highTempHighPressCathodic?: string | undefined;
    layer?: string | undefined;
    preference?: string | undefined;
    iogpStandard?: string[] | undefined;
    coats?: CoatViewModel[] | undefined;
    prevRevisionSystemId?: string | undefined;

    constructor(data?: ICoatingSystemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coatingSystemId = _data["coatingSystemId"];
            this.name = _data["name"];
            this.coatingSystemCategory = _data["coatingSystemCategory"];
            this.technologyStandard = _data["technologyStandard"];
            this.technologyStandardName = _data["technologyStandardName"];
            this.service = _data["service"];
            this.vocCategory = _data["vocCategory"];
            this.coatingSystemType = _data["coatingSystemType"];
            this.surfacePrep = _data["surfacePrep"];
            this.anchorPattern = _data["anchorPattern"];
            this.totalDFT = _data["totalDFT"];
            this.touchUp = _data["touchUp"];
            this.coatingSystemNotes = _data["coatingSystemNotes"];
            if (Array.isArray(_data["substrateMaterial"])) {
                this.substrateMaterial = [] as any;
                for (let item of _data["substrateMaterial"])
                    this.substrateMaterial!.push(item);
            }
            if (Array.isArray(_data["equipmentGroup"])) {
                this.equipmentGroup = [] as any;
                for (let item of _data["equipmentGroup"])
                    this.equipmentGroup!.push(item);
            }
            if (Array.isArray(_data["equipmentDescription"])) {
                this.equipmentDescription = [] as any;
                for (let item of _data["equipmentDescription"])
                    this.equipmentDescription!.push(item);
            }
            this.physicalAbuse = _data["physicalAbuse"];
            if (Array.isArray(_data["applicationEnvironment"])) {
                this.applicationEnvironment = [] as any;
                for (let item of _data["applicationEnvironment"])
                    this.applicationEnvironment!.push(item);
            }
            if (Array.isArray(_data["exposureCycle"])) {
                this.exposureCycle = [] as any;
                for (let item of _data["exposureCycle"])
                    this.exposureCycle!.push(item);
            }
            this.exposureToTemperature = _data["exposureToTemperature"];
            this.highTempHighPressCathodic = _data["highTempHighPressCathodic"];
            this.layer = _data["layer"];
            this.preference = _data["preference"];
            if (Array.isArray(_data["iogpStandard"])) {
                this.iogpStandard = [] as any;
                for (let item of _data["iogpStandard"])
                    this.iogpStandard!.push(item);
            }
            if (Array.isArray(_data["coats"])) {
                this.coats = [] as any;
                for (let item of _data["coats"])
                    this.coats!.push(CoatViewModel.fromJS(item));
            }
            this.prevRevisionSystemId = _data["prevRevisionSystemId"];
        }
    }

    static fromJS(data: any): CoatingSystemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingSystemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coatingSystemId"] = this.coatingSystemId;
        data["name"] = this.name;
        data["coatingSystemCategory"] = this.coatingSystemCategory;
        data["technologyStandard"] = this.technologyStandard;
        data["technologyStandardName"] = this.technologyStandardName;
        data["service"] = this.service;
        data["vocCategory"] = this.vocCategory;
        data["coatingSystemType"] = this.coatingSystemType;
        data["surfacePrep"] = this.surfacePrep;
        data["anchorPattern"] = this.anchorPattern;
        data["totalDFT"] = this.totalDFT;
        data["touchUp"] = this.touchUp;
        data["coatingSystemNotes"] = this.coatingSystemNotes;
        if (Array.isArray(this.substrateMaterial)) {
            data["substrateMaterial"] = [];
            for (let item of this.substrateMaterial)
                data["substrateMaterial"].push(item);
        }
        if (Array.isArray(this.equipmentGroup)) {
            data["equipmentGroup"] = [];
            for (let item of this.equipmentGroup)
                data["equipmentGroup"].push(item);
        }
        if (Array.isArray(this.equipmentDescription)) {
            data["equipmentDescription"] = [];
            for (let item of this.equipmentDescription)
                data["equipmentDescription"].push(item);
        }
        data["physicalAbuse"] = this.physicalAbuse;
        if (Array.isArray(this.applicationEnvironment)) {
            data["applicationEnvironment"] = [];
            for (let item of this.applicationEnvironment)
                data["applicationEnvironment"].push(item);
        }
        if (Array.isArray(this.exposureCycle)) {
            data["exposureCycle"] = [];
            for (let item of this.exposureCycle)
                data["exposureCycle"].push(item);
        }
        data["exposureToTemperature"] = this.exposureToTemperature;
        data["highTempHighPressCathodic"] = this.highTempHighPressCathodic;
        data["layer"] = this.layer;
        data["preference"] = this.preference;
        if (Array.isArray(this.iogpStandard)) {
            data["iogpStandard"] = [];
            for (let item of this.iogpStandard)
                data["iogpStandard"].push(item);
        }
        if (Array.isArray(this.coats)) {
            data["coats"] = [];
            for (let item of this.coats)
                data["coats"].push(item.toJSON());
        }
        data["prevRevisionSystemId"] = this.prevRevisionSystemId;
        return data;
    }
}

export interface ICoatingSystemViewModel {
    id?: string;
    coatingSystemId: string;
    name: string;
    coatingSystemCategory: string;
    technologyStandard: string;
    technologyStandardName?: string | undefined;
    service: string;
    vocCategory?: string | undefined;
    coatingSystemType?: string | undefined;
    surfacePrep?: string | undefined;
    anchorPattern?: string | undefined;
    totalDFT?: string | undefined;
    touchUp?: string | undefined;
    coatingSystemNotes?: string | undefined;
    substrateMaterial?: string[] | undefined;
    equipmentGroup?: string[] | undefined;
    equipmentDescription?: string[] | undefined;
    physicalAbuse?: string | undefined;
    applicationEnvironment?: string[] | undefined;
    exposureCycle?: string[] | undefined;
    exposureToTemperature?: string | undefined;
    highTempHighPressCathodic?: string | undefined;
    layer?: string | undefined;
    preference?: string | undefined;
    iogpStandard?: string[] | undefined;
    coats?: CoatViewModel[] | undefined;
    prevRevisionSystemId?: string | undefined;
}

export class CoatingsSearchFilterModel implements ICoatingsSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    technologyStandardId?: string | undefined;

    constructor(data?: ICoatingsSearchFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDisplayName = _data["filterDisplayName"];
            this.filterPropertyName = _data["filterPropertyName"];
            this.filterType = _data["filterType"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.technologyStandardId = _data["technologyStandardId"];
        }
    }

    static fromJS(data: any): CoatingsSearchFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoatingsSearchFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDisplayName"] = this.filterDisplayName;
        data["filterPropertyName"] = this.filterPropertyName;
        data["filterType"] = this.filterType;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["technologyStandardId"] = this.technologyStandardId;
        return data;
    }
}

export interface ICoatingsSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    technologyStandardId?: string | undefined;
}

export class ProductServiceTemperatureViewModel implements IProductServiceTemperatureViewModel {
    serviceId!: string;
    service?: string | undefined;
    coatingProductId?: string;
    serviceTempMaxC?: string | undefined;

    constructor(data?: IProductServiceTemperatureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.service = _data["service"];
            this.coatingProductId = _data["coatingProductId"];
            this.serviceTempMaxC = _data["serviceTempMaxC"];
        }
    }

    static fromJS(data: any): ProductServiceTemperatureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductServiceTemperatureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["service"] = this.service;
        data["coatingProductId"] = this.coatingProductId;
        data["serviceTempMaxC"] = this.serviceTempMaxC;
        return data;
    }
}

export interface IProductServiceTemperatureViewModel {
    serviceId: string;
    service?: string | undefined;
    coatingProductId?: string;
    serviceTempMaxC?: string | undefined;
}

export class RevisionApprovalViewModel implements IRevisionApprovalViewModel {
    id?: number;
    coatingRevisionId?: number;
    approverOid?: string;
    name?: string | undefined;
    status?: RevisionApprovalStatus;
    approverType?: ApproverType;
    dueDate?: Date;
    updatedAt?: Date;

    constructor(data?: IRevisionApprovalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coatingRevisionId = _data["coatingRevisionId"];
            this.approverOid = _data["approverOid"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.approverType = _data["approverType"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RevisionApprovalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionApprovalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coatingRevisionId"] = this.coatingRevisionId;
        data["approverOid"] = this.approverOid;
        data["name"] = this.name;
        data["status"] = this.status;
        data["approverType"] = this.approverType;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRevisionApprovalViewModel {
    id?: number;
    coatingRevisionId?: number;
    approverOid?: string;
    name?: string | undefined;
    status?: RevisionApprovalStatus;
    approverType?: ApproverType;
    dueDate?: Date;
    updatedAt?: Date;
}

export class RevisionCommentViewModel implements IRevisionCommentViewModel {
    id?: number;
    comment!: string;
    coatingRevisionId!: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    linkedCoatingSystemId?: string | undefined;
    linkedCoatingProductId?: string | undefined;
    linkedCoatingSystemSolutionId?: string | undefined;
    replies?: RevisionCommentViewModel[] | undefined;

    constructor(data?: IRevisionCommentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.coatingRevisionId = _data["coatingRevisionId"];
            this.createdByOid = _data["createdByOid"];
            this.updatedByOid = _data["updatedByOid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.parentCommentId = _data["parentCommentId"];
            this.linkedCoatingSystemId = _data["linkedCoatingSystemId"];
            this.linkedCoatingProductId = _data["linkedCoatingProductId"];
            this.linkedCoatingSystemSolutionId = _data["linkedCoatingSystemSolutionId"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [] as any;
                for (let item of _data["replies"])
                    this.replies!.push(RevisionCommentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionCommentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionCommentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["coatingRevisionId"] = this.coatingRevisionId;
        data["createdByOid"] = this.createdByOid;
        data["updatedByOid"] = this.updatedByOid;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["parentCommentId"] = this.parentCommentId;
        data["linkedCoatingSystemId"] = this.linkedCoatingSystemId;
        data["linkedCoatingProductId"] = this.linkedCoatingProductId;
        data["linkedCoatingSystemSolutionId"] = this.linkedCoatingSystemSolutionId;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (let item of this.replies)
                data["replies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRevisionCommentViewModel {
    id?: number;
    comment: string;
    coatingRevisionId: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    linkedCoatingSystemId?: string | undefined;
    linkedCoatingProductId?: string | undefined;
    linkedCoatingSystemSolutionId?: string | undefined;
    replies?: RevisionCommentViewModel[] | undefined;
}

export class RevisionSummaryViewModel implements IRevisionSummaryViewModel {
    id?: number;
    name?: string | undefined;
    authorOid?: string;
    activeComments?: number;
    status?: RevisionStatus;
    publishDate?: Date;
    isRejected?: boolean;

    constructor(data?: IRevisionSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.authorOid = _data["authorOid"];
            this.activeComments = _data["activeComments"];
            this.status = _data["status"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.isRejected = _data["isRejected"];
        }
    }

    static fromJS(data: any): RevisionSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["authorOid"] = this.authorOid;
        data["activeComments"] = this.activeComments;
        data["status"] = this.status;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["isRejected"] = this.isRejected;
        return data;
    }
}

export interface IRevisionSummaryViewModel {
    id?: number;
    name?: string | undefined;
    authorOid?: string;
    activeComments?: number;
    status?: RevisionStatus;
    publishDate?: Date;
    isRejected?: boolean;
}

export class SolutionCoat implements ISolutionCoat {
    coatModel?: CoatViewModel;
    products?: CoatingProductViewModel[] | undefined;

    constructor(data?: ISolutionCoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coatModel = _data["coatModel"] ? CoatViewModel.fromJS(_data["coatModel"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CoatingProductViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SolutionCoat {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionCoat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coatModel"] = this.coatModel ? this.coatModel.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISolutionCoat {
    coatModel?: CoatViewModel;
    products?: CoatingProductViewModel[] | undefined;
}

export class TechnologyStandardViewModel implements ITechnologyStandardViewModel {
    id?: string | undefined;
    technologyStandardName?: string | undefined;

    constructor(data?: ITechnologyStandardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.technologyStandardName = _data["technologyStandardName"];
        }
    }

    static fromJS(data: any): TechnologyStandardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyStandardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["technologyStandardName"] = this.technologyStandardName;
        return data;
    }
}

export interface ITechnologyStandardViewModel {
    id?: string | undefined;
    technologyStandardName?: string | undefined;
}

export class WorkspaceEntryViewModel implements IWorkspaceEntryViewModel {
    id?: string;
    userOid?: string;
    coatingSystemSolutionId?: string;
    coatingSolution?: CoatingSystemSolutionViewModel;

    constructor(data?: IWorkspaceEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userOid = _data["userOid"];
            this.coatingSystemSolutionId = _data["coatingSystemSolutionId"];
            this.coatingSolution = _data["coatingSolution"] ? CoatingSystemSolutionViewModel.fromJS(_data["coatingSolution"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkspaceEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userOid"] = this.userOid;
        data["coatingSystemSolutionId"] = this.coatingSystemSolutionId;
        data["coatingSolution"] = this.coatingSolution ? this.coatingSolution.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkspaceEntryViewModel {
    id?: string;
    userOid?: string;
    coatingSystemSolutionId?: string;
    coatingSolution?: CoatingSystemSolutionViewModel;
}

export class EsraSearchFilterModel implements IEsraSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;

    constructor(data?: IEsraSearchFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDisplayName = _data["filterDisplayName"];
            this.filterPropertyName = _data["filterPropertyName"];
            this.filterType = _data["filterType"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static fromJS(data: any): EsraSearchFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new EsraSearchFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDisplayName"] = this.filterDisplayName;
        data["filterPropertyName"] = this.filterPropertyName;
        data["filterType"] = this.filterType;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    }
}

export interface IEsraSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
}

export enum FilterType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class FilterableProperty implements IFilterableProperty {
    displayName?: string | undefined;
    propertyName?: string | undefined;
    filterOptions?: string[] | undefined;
    filterType?: FilterType;

    constructor(data?: IFilterableProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.propertyName = _data["propertyName"];
            if (Array.isArray(_data["filterOptions"])) {
                this.filterOptions = [] as any;
                for (let item of _data["filterOptions"])
                    this.filterOptions!.push(item);
            }
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): FilterableProperty {
        data = typeof data === 'object' ? data : {};
        let result = new FilterableProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["propertyName"] = this.propertyName;
        if (Array.isArray(this.filterOptions)) {
            data["filterOptions"] = [];
            for (let item of this.filterOptions)
                data["filterOptions"].push(item);
        }
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IFilterableProperty {
    displayName?: string | undefined;
    propertyName?: string | undefined;
    filterOptions?: string[] | undefined;
    filterType?: FilterType;
}

export class SearchRequest implements ISearchRequest {
    page?: number;
    perPage?: number;
    mainSearch?: string | undefined;
    filters?: FilterableProperty[] | undefined;
    orderBy?: string | undefined;
    highlightMatches?: boolean;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.mainSearch = _data["mainSearch"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterableProperty.fromJS(item));
            }
            this.orderBy = _data["orderBy"];
            this.highlightMatches = _data["highlightMatches"];
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["mainSearch"] = this.mainSearch;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["orderBy"] = this.orderBy;
        data["highlightMatches"] = this.highlightMatches;
        return data;
    }
}

export interface ISearchRequest {
    page?: number;
    perPage?: number;
    mainSearch?: string | undefined;
    filters?: FilterableProperty[] | undefined;
    orderBy?: string | undefined;
    highlightMatches?: boolean;
}

export class SearchResponse_1OfCoatingSystemSolutionViewModel implements ISearchResponse_1OfCoatingSystemSolutionViewModel {
    totalResults?: number;
    results?: CoatingSystemSolutionViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfCoatingSystemSolutionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CoatingSystemSolutionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfCoatingSystemSolutionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfCoatingSystemSolutionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfCoatingSystemSolutionViewModel {
    totalResults?: number;
    results?: CoatingSystemSolutionViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export class SimpleObjectViewModel implements ISimpleObjectViewModel {
    id?: string;
    name?: string | undefined;
    toBeDeleted?: boolean;

    constructor(data?: ISimpleObjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.toBeDeleted = _data["toBeDeleted"];
        }
    }

    static fromJS(data: any): SimpleObjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleObjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["toBeDeleted"] = this.toBeDeleted;
        return data;
    }
}

export interface ISimpleObjectViewModel {
    id?: string;
    name?: string | undefined;
    toBeDeleted?: boolean;
}

export enum RevisionStatus {
    DRAFT = 0,
    REVIEW = 1,
    APPROVAL = 2,
    PUBLISHED = 3,
    REVIEW_WITH_REJECTIONS = 10,
    REVIEW_WITH_PENDING_COMMENTS = 11,
    APPROVAL_WITH_PENDING_COMMENTS = 12,
    RETIRED = 100,
    REJECTED = 101,
}

export class EnvironmentIndicatorViewModel implements IEnvironmentIndicatorViewModel {
    azureSearchPath?: string | undefined;
    version?: string | undefined;
    versionInfo?: VersionInfo;

    constructor(data?: IEnvironmentIndicatorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureSearchPath = _data["azureSearchPath"];
            this.version = _data["version"];
            this.versionInfo = _data["versionInfo"] ? VersionInfo.fromJS(_data["versionInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnvironmentIndicatorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentIndicatorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureSearchPath"] = this.azureSearchPath;
        data["version"] = this.version;
        data["versionInfo"] = this.versionInfo ? this.versionInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnvironmentIndicatorViewModel {
    azureSearchPath?: string | undefined;
    version?: string | undefined;
    versionInfo?: VersionInfo;
}

export class EsraRecordLabel implements IEsraRecordLabel {
    recordId?: string | undefined;
    label?: string | undefined;

    constructor(data?: IEsraRecordLabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): EsraRecordLabel {
        data = typeof data === 'object' ? data : {};
        let result = new EsraRecordLabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId;
        data["label"] = this.label;
        return data;
    }
}

export interface IEsraRecordLabel {
    recordId?: string | undefined;
    label?: string | undefined;
}

export class VersionInfo implements IVersionInfo {
    version?: string | undefined;
    commitHash?: string | undefined;
    commitDate?: string | undefined;
    assemblyName?: string | undefined;

    constructor(data?: IVersionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.commitHash = _data["commitHash"];
            this.commitDate = _data["commitDate"];
            this.assemblyName = _data["assemblyName"];
        }
    }

    static fromJS(data: any): VersionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VersionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["commitHash"] = this.commitHash;
        data["commitDate"] = this.commitDate;
        data["assemblyName"] = this.assemblyName;
        return data;
    }
}

export interface IVersionInfo {
    version?: string | undefined;
    commitHash?: string | undefined;
    commitDate?: string | undefined;
    assemblyName?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}